"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlFilename = void 0;
var urlFilename = function (url) {
  var path = url.substring(url.lastIndexOf("/") + 1);
  return (path.match(/[^.]+(\.[^?#]+)?/) || [])[0];
};
exports.urlFilename = urlFilename;